import type { Translation } from 'primeng/api';

/**
 * Календарът на datepicker-а по езици (#302). PrimeNG носи само английски;
 * `firstDayOfWeek: 1` — седмицата започва в понеделник и в двата езика.
 */
export const PRIMENG_TRANSLATIONS: Record<string, Translation> = {
  bg: {
    firstDayOfWeek: 1,
    accept: 'Да',
    reject: 'Не',
    dayNames: ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'],
    dayNamesShort: ['нед', 'пон', 'вто', 'сря', 'чет', 'пет', 'съб'],
    dayNamesMin: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
    monthNames: ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'],
    monthNamesShort: ['яну', 'фев', 'мар', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'],
    today: 'Днес',
    clear: 'Изчисти',
    weekHeader: 'Сед',
    dateFormat: 'dd.mm.yy',
  },
  en: {
    firstDayOfWeek: 1,
    accept: 'Yes',
    reject: 'No',
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear',
    weekHeader: 'Wk',
    dateFormat: 'dd.mm.yy',
  },
};
